import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzRadioModule } from 'ng-zorro-antd/radio';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzSwitchModule } from 'ng-zorro-antd/switch';

import { TranslateModule } from '@ngx-translate/core';

import { SharedDirectivesModule } from '../../shared-directives.module';

import { InputTagModule } from '../input-tag/input-tag.module';
import { DisplayFilterSelectionPipe } from './advanced-filter-display-text.pipe';
import { AdvancedFilterComponent } from './advanced-filter.component';

@NgModule({
  declarations: [AdvancedFilterComponent, DisplayFilterSelectionPipe],
  imports: [
    FormsModule,
    CommonModule,
    ReactiveFormsModule,

    NzSpinModule,
    NzInputModule,
    NzButtonModule,
    NzSwitchModule,
    NzCheckboxModule,
    NzRadioModule,
    NzDropDownModule,

    TranslateModule,
    InputTagModule,
    SharedDirectivesModule,
  ],
  exports: [AdvancedFilterComponent],
})
export class AdvancedFilterModule {}
